<template>
  <div class="e-learning-modal">
    <div :class="['e-learning-info', {'modal-close-info': !this.modalType}]">
      <app-border-top />
      <div class="close-learning-modal" @click="leaveQuiz()" v-if="!isTimeOver">
        <img src="images/learning/close.svg" alt />
      </div>
      <template v-if="!isTimeOver">
        <div v-if="this.modalType && !this.isTest" class="info-container">
          <div class="info-image">
            <img src="images/learning/learning-info.svg" alt />
          </div>
          <h2 class="pt-2">{{cms.eLearningInfoHeader}}</h2>
          <ul>
            <li v-for="(title, i) in cms.eLearningInfoTitles" :key="i">{{title}}</li>
          </ul>
          <div class="info-buttons">
            <button
              class="btn btn-secondary"
              v-for="(button, i) in cms.eLearningInfoButtons"
              :key="i"
              @click="infoModalAction(cms.eLearningInfoActions[i])"
            >{{button}}</button>
          </div>
        </div>
        <div v-else-if="!this.modalType && !this.isTest" class="info-container close-info">
          <h2>{{cms.eLearningCloseHeader}}</h2>
          <div class="close-buttons">
            <button
              class="btn btn-secondary"
              v-for="(button, i) in cms.eLearningCloseButtons"
              :key="i"
              @click="exitModalAction(cms.eLearningCloseActions[i])"
            >{{button}}</button>
          </div>
        </div>
        <div v-else class="info-container close-info">
          <h2>{{cms.eLearningCloseTestTitle}}</h2>
          <div class="close-buttons">
            <button
              class="btn btn-secondary"
              v-for="(button, i) in cms.eLearningCloseTestButtons"
              :key="i"
              @click="exitModalAction(cms.eLearningCloseActions[i])"
            >{{button}}</button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="info-container close-info">
          <h2>{{cms.eLearningInfoTimeOver}}</h2>
          <div class="close-buttons">
            <button
              class="btn btn-secondary"
              v-for="(button, i) in cms.eLearningTimeOverButtons"
              :key="i"
              @click="timeIsOverAction(cms.eLearningCloseActions[i])"
            >{{button}}</button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AppBorderTop from "@/components/AppBorderTop";
import { eLearningModalMethods } from "@/mixins/e-learning-modal.js";
export default {
  data() {
    return {
      /* eslint-disable */
      cms: {
        eLearningInfoHeader: ELEARNING_INFO_HEADER,
        eLearningInfoTitles: ELEARNING_INFO_TITLES,
        eLearningInfoButtons: ELEARNING_INFO_BTNS,
        eLearningInfoActions: ELEARNING_INFO_ACTIONS,

        eLearningCloseHeader: ELEARNING_CLOSE_HEADER,
        eLearningCloseButtons: ELEARNING_CLOSE_BTNS,
        eLearningCloseTestTitle: ELEARNING_CLOSE_TEST,
        eLearningCloseTestButtons: ELEARNING_CLOSE_TEST_BTNS,
        eLearningCloseActions: ELEARNING_CLOSE_ACTIONS,

        eLearningInfoTimeOver: ELEARNING_TIME_OVER_TEST,
        eLearningTimeOverButtons: ELEARNING_TIME_OVER_BTNS
      }
      /* eslint-enable */
    };
  },
  mixins: [eLearningModalMethods],
  props: {
    modalType: {
      type: Boolean,
      required: false,
      default: false
    },
    videoSection: {
      type: Boolean,
      required: false,
      default: false
    },
    leavePage: {
      type: Boolean,
      required: false,
      default: false
    },
    changePath: {
      type: String,
      required: false,
      default: ""
    },
    isTest: {
      type: Boolean,
      required: false,
      default: false
    },
    isTimeOver: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    AppBorderTop
  }
};
</script>
